import React, { useState } from "react";
import "./index.scss";
import { DisclaimerModel } from "./models/Disclaimer.model";
import { DisclaimerProps } from "./types/Disclaimer.type";
import LazySection from "../../react-only-components/LazySection";
import {
  Text,
  withSitecoreContext,
  RichText,
  isEditorActive,
} from "@sitecore-jss/sitecore-jss-react";
import { useLocation, useNavigate } from "react-router-dom";

const Disclaimer = (props: DisclaimerProps) => {
  const model = new DisclaimerModel(props);
  const [option, setOption] = useState("");
  const [disagreeButton, setDisAgreeButton] = useState(false);
  // const cookie = document.cookie.match(/^(.*;)?\s*DEMDISC\s*=\s*[^;]+(.*)?$/)
  const location = useLocation();
  const navigate = useNavigate();

  const handleSubmit = (e, option, model) => {
    e.preventDefault();
    if (option === "disagree") {
      setDisAgreeButton(true);
      window && window.scroll(0, 0);
    }
    if (option === "agree") {
      const currentPath = location?.pathname;
      const currentPathURL = window?.location?.href ?? '';
      let url = new URL(currentPathURL);
      let c = url.searchParams.get("returnUrl");
      if (typeof document!== 'undefined') {
        document.cookie =
        model.fields?.cookie?.fields?.cookiename?.value +
        "=" +
        model.fields?.cookie?.fields?.cookievalue?.value +
        ";path=/;";
      }
      
      if (c !== null) {
        // history.push(c, { params: { forceReload: true } })
        window && window.open(
          window.location.protocol + `//` + window.location.host + c,
          "_blank"
        );
        navigate(currentPath); //, { params: { forceReload: true } });
      } else {
        navigate(currentPath); //, { params: { forceReload: true } });
      }
      window && window.scroll(0, 0);
    }
  };

  return (
    <LazySection offset={0} id={props.rendering?.uid}>
      {props.fields && (
        <div id={props?.rendering?.uid}>
          {!disagreeButton ? (
            <form
              className="disclaimer__wrapper"
              onSubmit={(e) => handleSubmit(e, option, model)}
            >
              <div className="disclaimer__note">
                <RichText field={props.fields?.disclaimernote} />
              </div>
              <div className="disclaimer__radioButtons">
                {props.fields?.optionsnamevaluelist?.map((item, i) => (
                  <div key={i}>
                    <div className="disclaimer__radioButton">
                      <input
                        type="radio"
                        value={item.fields?.value?.value}
                        id={item.fields?.key?.value}
                        name={item.fields?.key?.value}
                        className="disclaimer__radioButton_input"
                        checked={option === item.fields?.key?.value}
                        onChange={(e) => setOption(item.fields?.key?.value ?? '')}
                      />

                      <Text
                        field={item.fields?.value}
                        tag="label"
                        for={item.fields?.key?.value}
                        className="disclaimer__radioButton_label"
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className="disclaimer__buttonWrapper">
                {isEditorActive() ? (
                  <Text
                    field={props.fields?.ctalabel}
                    className="disclaimer__submitButton"
                  />
                ) : (
                  <button className="disclaimer__submitButton" type="submit">
                    {props.fields?.ctalabel?.value}
                  </button>
                )}
              </div>
            </form>
          ) : (
            <div className="disagreeNote__wrapper">
              <RichText
                field={props.fields?.disclaimerdisagreenote}
                className="disagreeNote"
              />
            </div>
          )}
        </div>
      )}
    </LazySection>
  );
};

export default withSitecoreContext()(Disclaimer);
